// src/components/Sidebar.js
import React, { useEffect, useState } from "react";
import "./support.scss"; // Import CSS for Sidebar styling
import {
  Alert,
  Badge,
  Box,
  Button,
  CircularProgress,
  IconButton,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { FilterAlt } from "@mui/icons-material";
import {
  collection,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import { handleInputNumber } from "../../context/commonFunctions";
import { ProgressDialog, ShowSnackBar } from "../../components/modal";
const ChatSidebar = ({ setSelectedRequest }) => {
  const [initialLoading, setInitialLoading] = useState(true);
  const [ticketList, setTicketList] = useState([]);
  const [isEmpty, setEmpty] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [selectedTicket, setSelectedTicket] = useState("");
  const [statusFilter, setStatusFilter] = useState("open");
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [showProgressLoading, setShowProgressLoading] = useState(false);

  const handleRequestClick = (ticket) => {
    setSelectedRequest(ticket);
    setSelectedTicket(ticket.id);
  };

  const handleCloseSnackBar = () => {
    setOpenSnackBar(false);
  };

  useEffect(() => {
    document.title = "Wishallbook >> Chat support";

    const queryRef = query(
      collection(db, "supportChats"),
      where("status", "==", statusFilter),
      orderBy("timestamp", "desc")
    );
    const unsubscribe = onSnapshot(queryRef, (querySnapshot) => {
      setInitialLoading(false);
      if (querySnapshot.empty) {
        setEmpty(true);
        setTicketList([]);
      } else {
        setEmpty(false);
        const tickets = querySnapshot.docs.map((ticket) => {
          const data = ticket.data();
          return { id: ticket.id, ...data };
        });
        setTicketList(tickets);
      }
    });
    return () => unsubscribe();
  }, [statusFilter]);
  const handleSearchInput = (event) => {
    const { value } = event.target;
    setSearchValue(value);
  };

  const handleFilterChange = (filter) => {
    if (statusFilter != filter) {
      setStatusFilter(filter);
      setTicketList([]);
      setSelectedRequest(null);
      setSelectedTicket("");
      setInitialLoading(true);
    }
  };

  const handleKeyPress = async (event) => {
    if (event.key === "Enter") {
      //perform search

      try {
        setShowProgressLoading(true);
        const q = query(
          collection(db, "supportChats"),
          where("ticketID", "==", event.target.value),
          limit(1)
        );
        const querySnapshot = await getDocs(q);
        setShowProgressLoading(false);
        if (querySnapshot.empty) {
          setOpenSnackBar(true);
        } else {
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            setSelectedRequest({ id: doc.id, ...data });
            setSelectedTicket(doc.id);
            setSearchValue("")
          });
        }
      } catch (error) {
        setShowProgressLoading(false);
      }
    }
  };
  return (
    <div className="chatSidebar">
      {ticketList.length != 0 && (
        <h2>
          {ticketList.length} {statusFilter.toUpperCase()} tickets
        </h2>
      )}
      <div className="search">
        <Stack direction={"row"} justifyContent={"space-between"}>
          <TextField
            label="Search Ticket ID here..."
            variant="outlined"
            value={searchValue}
            onInput={handleInputNumber}
            onKeyPress={handleKeyPress}
            onChange={handleSearchInput}
          />
          <IconButton
            className="nav-link dropdown-toggle"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <FilterAlt />
          </IconButton>
          <ul className="dropdown-menu">
            <li>
              <Button
                variant="text"
                className="dropdown-item"
                onClick={() => handleFilterChange("open")}
              >
                Open Tickets
              </Button>
            </li>
            <li>
              <Button
                variant="text"
                className="dropdown-item"
                onClick={() => handleFilterChange("closed")}
              >
                Closed Tickets
              </Button>
            </li>
          </ul>
        </Stack>
        <ShowSnackBar
          handleCloseSnackBar={handleCloseSnackBar}
          openSnackBar={openSnackBar}
          message={"We couldn't find a ticket with that ID."}
          type={"error"}
        />
        <ProgressDialog
          loading={showProgressLoading}
          message={"Please wait..."}
        />
      </div>
      {initialLoading && (
        <div className="center">
          <CircularProgress />
        </div>
      )}
      {ticketList.length != 0 && (
        <div className="requests">
          {ticketList.map((ticket, index) => {
            // Get the last message object and its text field
            const lastMessage =
              ticket.messages && ticket.messages.length > 0
                ? ticket.messages[ticket.messages.length - 1].message
                : "No message available";
            const lastMessageFrom =
              ticket.messages && ticket.messages.length > 0
                ? ticket.messages[ticket.messages.length - 1].from
                : "N/A";

            return (
              <Box
                key={index}
                padding="10px"
                sx={{
                  borderBottom: "1px solid #A9BDD6",
                  cursor: "pointer",
                  bgcolor: ticket.id == selectedTicket ? "#d9ecff" : "#fff",
                }}
                onClick={() => {
                  if (ticket.id != selectedTicket) handleRequestClick(ticket);
                }}
              >
                <Stack direction={"row"}>
                  <Typography
                    color="#000000"
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Ticket ID {ticket.ticketID}
                  </Typography>
                  {ticket.setAdminStatus && ticket.setAdminStatus == true && (
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        backgroundColor: "#ff0000",
                        borderRadius: "50%",
                        display: "inline-block",
                        margin: " 7px",
                      }}
                    />
                  )}
                </Stack>
                <Typography
                  color={
                    ticket.setAdminStatus && ticket.setAdminStatus === true
                      ? "primary"
                      : "#778596"
                  }
                  fontSize={12}
                  sx={{
                    maxWidth: "300px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {(lastMessageFrom == "admin" ? "You: " : "") + lastMessage}
                </Typography>
              </Box>
            );
          })}
        </div>
      )}
      {ticketList.length == 0 && !initialLoading && (
        <div className="center">
          <Typography>
            You currently have no {statusFilter} support tickets.
          </Typography>
        </div>
      )}
    </div>
  );
};

export default ChatSidebar;
